import { render, staticRenderFns } from "./SistemasEServicos.vue?vue&type=template&id=1b8860f4&scoped=true"
import script from "./SistemasEServicos.vue?vue&type=script&lang=js"
export * from "./SistemasEServicos.vue?vue&type=script&lang=js"
import style0 from "./SistemasEServicos.vue?vue&type=style&index=0&id=1b8860f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8860f4",
  null
  
)

export default component.exports